export const runbookVersionConstants = {
  GET_REQUEST: "GET_RUNBOOK_VERSION_REQUEST",
  GET_SUCCESS: "GET_RUNBOOK_VERSION_SUCCESS",
  GET_FAILURE: "GET_RUNBOOK_VERSION_FAILURE",
  CREATE_REQUEST: "CREATE_RUNBOOK_VERSION_REQUEST",
  CREATE_SUCCESS: "CREATE_RUNBOOK_VERSION_SUCCESS",
  CREATE_FAILURE: "CREATE_RUNBOOK_VERSION_FAILURE",
};
